import { LitElement, html, css } from "lit";
class FancyHomeAnimator extends LitElement {
	constructor() {
		super();

		this.topCell = null;
		this.bottomCell = null;
		this.line = null;
		this.logo = null;
		this.logoLink = "/wp-content/themes/posturepress3/assets/images/lavish-logo-white.svg";

		// Check to see if a seenCookie has been set on the document
		this.seenCookie = document.cookie.includes("seenLandingPage=true");

		if (this.seenCookie) {
			this.style.display = "none";

			// stop css animations from running
			this.style.animationPlayState = "paused";

			// trigger animationend event
			setTimeout(() => {
				this.dispatchEvent(new Event("animationend"));
			}, 1000)
		}
	}

	connectedCallback() {
		super.connectedCallback();
		this.topCell = this.querySelector(".top-cell");
		this.bottomCell = this.querySelector(".bottom-cell");
		this.logo = this.querySelector(".logo");
		this.line = this.querySelector(".cell-line");

		// Scroll the document to the top
		document.querySelector("html").scrollTo(0, 0, "instant");

		// after the element this has finished animating scroll to the next section
		this.addEventListener("animationend", (event) => {
			// scroll to the element .moments-grid
			if (event.animationName === "removeOverlay") {
				const momentsGrid = document.querySelector(".moments-grid");
				scrollToCustom(document.documentElement, momentsGrid.offsetTop, 750);

				// set the cookie
				document.cookie = "seenLandingPage=true;";
			}
		});
	}

	createRenderRoot() {
		return this;
	}

	render() {
		return html`
			<div class="animation-container">
				<div class="cell-wrap">
					<div class="top-cell"></div>
					<div class="cell-line"></div>
					<div class="bottom-cell"></div>
				</div>
				<div class="logo-wrap">
					<img src="${this.logoLink}" alt="Lavish Logo" class="logo" />
				</div>
			</div>
		`;
	}
}

function scrollToCustom(element, to, duration) {
	if (duration <= 0) return;
	const difference = to - element.scrollTop;
	const perTick = (difference / duration) * 10;
	// add easing to the per-tick value
	const easeInOut = (t) => {
		return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	};

	setTimeout(function () {
		element.scrollTo({
			top: element.scrollTop + perTick,
			behavior: "instant",
		});
		if (element.scrollTop === to) return;
		scrollToCustom(element, to, duration - 10);
	}, 10);
}

window.customElements.define("fancy-home-animator", FancyHomeAnimator);
